import { render, staticRenderFns } from "./c-default-card.vue?vue&type=template&id=cb2f952e&scoped=true&"
import script from "./c-default-card.vue?vue&type=script&lang=js&"
export * from "./c-default-card.vue?vue&type=script&lang=js&"
import style0 from "./c-default-card.vue?vue&type=style&index=0&id=cb2f952e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2f952e",
  null
  
)

export default component.exports